import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function NewTransactionsManagementToggleWrapper(
  props: {
    children: ReactNode,
    hideInDevelopment?: boolean,
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.NEW_TRANSACTIONS_MANAGEMENT}>
      {props.children}
    </ToggleWrapper>
  );
}

export function RequestNewMarketToggleWrapper(
  props: {
    children: ReactNode,
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.REQUEST_MARKETS}>
      {props.children}
    </ToggleWrapper>
  );
}
